import { Injectable, inject } from '@angular/core';
import { CaseTypeState } from '../../states/case-type.state';

@Injectable({ providedIn: 'root' })
export class SetCaseTypeActiveInStateUseCase {
  private readonly state = inject(CaseTypeState);

  public execute(id: string, isActive: boolean): void {
    const caseTypes = this.state.caseTypes();
    const caseType = caseTypes.find((ct) => ct.id === id);

    if (!caseType) {
      return;
    }

    const updatedCaseType = { ...caseType, isActive };
    this.state.updateCaseType(updatedCaseType);
  }
}
